var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ops-message"},[_c('h1',[_vm._v("登录失败")]),_c('h2',[_vm._v("当前登录服务不可用！")])])}]

export { render, staticRenderFns }